import { z } from "zod";

import { FeaturesCodes } from "@/pages/Private/pages/Users/enum/codes";

export const AdminFeatureCompanySchema = z.object({
	id: z.number(),
	name: z.string(),
});

export const AdminFeatureSchema = z.object({
	id: z.number(),
	feature: z.nativeEnum(FeaturesCodes),
	active: z.boolean(),
	companyId: z.number().nullable(),
	company: AdminFeatureCompanySchema.nullable(),
	createdAt: z.string(),
	updatedAt: z.string(),
});

export const AdminFeaturesResponseSchema = AdminFeatureSchema.array();

export type AdminFeature = z.infer<typeof AdminFeatureSchema>;
export type AdminFeaturesResponse = z.infer<typeof AdminFeaturesResponseSchema>;

export const CreateCompanyFeatureSchema = z.object({
	feature: z.nativeEnum(FeaturesCodes),
	companyId: z.number().min(1, "Company ID must be positive"),
	active: z.boolean(),
});

export type CreateCompanyFeature = z.infer<typeof CreateCompanyFeatureSchema>;
